import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StickyContainer } from 'react-sticky';
import styled, { ThemeProvider, css } from 'styled-components';

import Footer from '@zocdoc-frontend-common/components-footer';
import Page from '@zocdoc-frontend-common/components-page';
import Accessibility from '@zocdoc-frontend-common/components-accessibility';
import { TranslationWidget } from '@zocdoc-frontend-common/utils-translation';
import { MetricsProvider, Metrics } from '@zocdoc/frontend-metrics';
import { white } from '@zocdoc-mezzanine/foundations-colors';

import Header from '../Header';
import ModalContainer from './ModalContainer';
import { getPageId } from '../../../utils/getPageId';
import FullStory from '../FullStory';
import BookingGlobalStyles from './GlobalStylesComponent';
import { paths } from '../../paths';
import PatientInfoFormProvider from '../PatientInfoForm/PatientInfoFormProvider';
import customizeTheme from '../../utils/customizeTheme';
import SignUpFormProvider from '../SignUpForm/SignUpFormProvider';
import { isVaccineProcedure } from '../../utils/isCovidVaccine';

export class BookingContainerView extends Component {
    static propTypes = {
        showModal: PropTypes.bool.isRequired,
        showSecureHeader: PropTypes.bool.isRequired,
        modalContent: PropTypes.object,
        partnershipImageUrl: PropTypes.string,
        showYouSteppedAwayModal: PropTypes.func,
        onClickLoginModal: PropTypes.func,
        onCloseLoginModal: PropTypes.func,
        goBackToPatientInfo: PropTypes.func,
        onSubmitPatientInfoSuccess: PropTypes.func,
        onSubmitSignUpSuccess: PropTypes.func,
        loggedInUser: PropTypes.object,
        sendMetric: PropTypes.func,
    };

    handleWindowClose = () => this.props.exitPage(this.props.currentPage);

    componentDidMount() {
        const { queryError, showYouSteppedAwayModal } = this.props;

        if (queryError) {
            showYouSteppedAwayModal();
        }

        window.addEventListener('beforeunload', this.handleWindowClose, true);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.queryError &&
            prevProps.queryError !== this.props.queryError
        ) {
            this.props.showYouSteppedAwayModal();
        }
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.handleWindowClose,
            true
        );
    }

    maybeRenderLanguageTranslationHeader = () => {
        const { procedureId } = this.props;
        const procedureIdInt = parseInt(procedureId, 10);
        const ok = isVaccineProcedure(procedureIdInt);

        if (ok) {
            return (
                <TranslationWidget
                    data-test="translation-widget"
                    showTranslateButton={false}
                />
            );
        }
        return null;
    };

    render() {
        const {
            children,
            location,
            modalContent,
            params,
            partnershipImageUrl,
            showModal,
            showSecureHeader,
            onClickLoginLink,
            goBackToPatientInfo,
            onSubmitPatientInfoSuccess,
            onSubmitSignUpSuccess,
            sendMetric,
        } = this.props;

        const showBlizzardPage =
            location &&
            location.pathname &&
            (location.pathname.startsWith(paths.patientInfoPath) ||
                location.pathname.startsWith(paths.signUpPath) ||
                location.pathname.startsWith(paths.registerPath));
        const showSignUpPage =
            location &&
            location.pathname &&
            location.pathname.startsWith(paths.signUpPath);

        return (
            <MetricsProvider getPageId={getPageId}>
                <Metrics
                    bookingId={params.bookingId}
                    businessUnit="PatientWebApp"
                    sendMetric={sendMetric}
                >
                    <Accessibility appNameForMetrics="booking_web_app" />
                    <BookingGlobalStyles />
                    <ThemeProvider theme={customizeTheme(showSecureHeader)}>
                        <PatientInfoFormProvider
                            onSubmitSuccess={onSubmitPatientInfoSuccess}
                        >
                            <SignUpFormProvider
                                goBackToPatientInfo={goBackToPatientInfo}
                                onSubmitSuccess={onSubmitSignUpSuccess}
                            >
                                <Page data-test="booking-page">
                                    <FullStory bookingId={params.bookingId} />
                                    <Header
                                        data-test="booking-header"
                                        hideUserArea
                                        location={location}
                                        partnershipImageUrl={
                                            partnershipImageUrl
                                        }
                                        showSecureHeader={showSecureHeader}
                                        onClickLoginLink={onClickLoginLink}
                                        showBlizzardPage={showBlizzardPage}
                                        showSignUpPage={showSignUpPage}
                                        goBackToPatientInfo={
                                            goBackToPatientInfo
                                        }
                                    />
                                    {this.maybeRenderLanguageTranslationHeader()}
                                    <Main showBlizzardPage={showBlizzardPage}>
                                        {showModal ? (
                                            <ModalContainer
                                                modalContent={modalContent}
                                            />
                                        ) : null}
                                        <StickyContainer>
                                            {children}
                                        </StickyContainer>
                                    </Main>
                                    <StyledFooter data-test="booking-footer" />
                                </Page>
                            </SignUpFormProvider>
                        </PatientInfoFormProvider>
                    </ThemeProvider>
                </Metrics>
            </MetricsProvider>
        );
    }
}

const Main = styled.div`
    ${p =>
        p.showBlizzardPage &&
        css`
            background: ${white};
        `} {
    }
    flex-grow: 1;
    position: relative;
`;

const StyledFooter = styled(Footer)`
    flex-grow: 0;
`;
